import type { Db } from "./types";

export const finalize = (db: Db) => {
  // set contact status according to the latest note
  db.contact_notes
    .sort((a, b) => new Date(a.date).valueOf() - new Date(b.date).valueOf())
    .forEach((note) => {
      db.contacts[note.contact_id as number].status = note.status;
    });

  // lifecycle coherence: contacts on an open deal are at least Opportunity;
  // contacts on a won deal are Customers
  db.deals.forEach((deal) => {
    for (const contactId of deal.contact_ids ?? []) {
      const contact = db.contacts[contactId as number];
      if (!contact) continue;
      if (deal.stage === "won") {
        contact.lifecycle_stage = "customer";
      } else if (
        deal.stage !== "lost" &&
        contact.lifecycle_stage !== "customer"
      ) {
        contact.lifecycle_stage = "opportunity";
      }
    }
  });
};
